import React, { FunctionComponent, useCallback } from 'react';
import { DragDropContext, DropResult } from 'react-beautiful-dnd';
import { ActionItems } from './ActionItems';
import { IActionItemsBoardProps } from './types';
import { useDispatch } from 'react-redux';
import { openDialog } from '../../../../app/dialog/dialog.actions';
import { CirclePlusButton } from '../../common/CirclePlusButton';

export const ActionItemsBoard: FunctionComponent<IActionItemsBoardProps> = ({
  userIds,
  actionItems,
  adminIds,
  meetingId,
}) => {
  const dispatch = useDispatch();

  const handleDrop = useCallback((result: DropResult) => {
    // if (result.type === 'column') {
    //   dispatch(dndBoardList(result, meetingId, boardId));
    // } else {
    //   dispatch(dndTask(result, meetingId));
    // }
  }, []);

  const openCardItemDialog = useCallback(() => {
    dispatch(openDialog('trelloReplacementFormDialog', { meetingId }));
  }, [dispatch, meetingId]);

  return (
    <div className="row mb-25 mt-3">
      <div className="col-12">
        <div className="panel vto-text">
          <div className="panel-header small-header no-border pb-0">
            <h2 className="bold">Action Items</h2>
            <div className="ml-auto flex aic">
              <span className="btn-badge theme-color pointer popup_button" onClick={openCardItemDialog}>
                <CirclePlusButton title="Add Action Item" size={25} onClick={openCardItemDialog} />
              </span>
            </div>
          </div>
          <div className="cards-container-overflow">
            <DragDropContext onDragEnd={handleDrop}>
              <div className="cards-container" style={{ height: '75vh', overflow: 'auto' }}>
                {userIds.map((userId) => (
                  <ActionItems
                    userId={userId}
                    key={userId}
                    actionItems={actionItems}
                    adminIds={adminIds}
                    meetingId={meetingId}
                  />
                ))}
              </div>
            </DragDropContext>
          </div>
        </div>
      </div>
    </div>
  );
};
